const STORAGE_KEY = '_spc_usr'
const getUserStorage = ()=>{
    const user = localStorage.getItem(STORAGE_KEY)
    return user ? JSON.parse(user) : {
        acd: false,
        acn: null,
        tkn: null
    }
}

const setUserStorage = user => {
    localStorage.setItem(STORAGE_KEY, user ? JSON.stringify(user) : '')
}

const isNotBlank = value => {
    return typeof value !== "undefined" && value !== null && value !== ''
}

export default {
    namespaced: true,
    state(){
        const user = getUserStorage()

        return {
            accountConnected: user?.acd || false,
            account: user?.acn || null,
            token: user?.tkn || null
        }
    },
    getters: {
        getAccount: state => state.account,
        getToken: state => state.token,
        isAccountConnected: state => state.accountConnected,
        isAuthorized: state => isNotBlank(state.account) && isNotBlank(state.token)
    },
    actions: {
        setUser({commit}, user) {
            commit('SET_USER', user)
        },
        setAccount({commit}, account) {
            commit('SET_ACCOUNT', account)
        },
        setToken({commit}, token) {
            commit('SET_TOKEN', token)
        },
        setAccountConnected({commit}, connected) {
            commit('SET_ACCOUNT_CONNECTED', connected)
        },
        removeUser({commit}) {
            commit('REMOVE_USER')
        }
    },
    mutations: {
        SET_USER(state, user) {
            const acd = state.accountConnected = user?.accountConnected || false
            const acn = state.account = user?.user || null
            const tkn = state.token = user?.token || null
            setUserStorage({acd, acn, tkn})
        },
        SET_ACCOUNT(state, account) {
            const acd = state.accountConnected
            const acn = state.account = account
            const tkn = state.token
            setUserStorage({acd, acn, tkn})
        },
        SET_TOKEN(state, token) {
            const acd = state.accountConnected
            const acn = state.account
            const tkn = state.token = token
            setUserStorage({acd, acn, tkn})
        },
        SET_ACCOUNT_CONNECTED(state, connected) {
            const acd = state.accountConnected = typeof connected === "boolean" ? connected : false
            const acn = state.account
            const tkn = state.token
            setUserStorage({acd, acn, tkn})
        },
        REMOVE_USER(state) {
            const acd = state.accountConnected = false
            const acn = state.account = null
            const tkn = state.token = null
            setUserStorage({acd, acn, tkn})
        }
    }
}